import { useTranslation } from 'react-i18next'

import { Button, Drawer, RadioButtonOptionCard, Text } from '@reveni-io/reveni-ui'

import AddressOption from './AddressOption/AddressOption'
import useAddressSuggestionDrawer from './hooks/useAddressSuggestionDrawer/useAddressSuggestionDrawer'
import { addressOptions, addressOptionsRadioName, drawerOptions } from './constants'
import * as Styles from './styles'

const AddressSuggestionDrawer = ({ show, customerAddress, suggestedAddress, onConfirm, onClose }) => {
  const { t } = useTranslation()
  const { selectedOption, selectOption, differingFields, confirmSelection, closeDrawer } = useAddressSuggestionDrawer({
    customerAddress,
    suggestedAddress,
    onConfirm,
    onClose,
  })

  return (
    <Drawer show={show} onClose={closeDrawer} options={drawerOptions}>
      <Styles.Container>
        <Text type="titleM">{t('Revisa tu dirección')}</Text>
        <Styles.Options>
          <RadioButtonOptionCard
            name={addressOptionsRadioName}
            value={addressOptions.customer}
            title={t('Tu dirección')}
            description={<AddressOption address={customerAddress} differingFields={differingFields} />}
            selected={selectedOption === addressOptions.customer}
            onChange={selectOption}
          />
          <RadioButtonOptionCard
            name={addressOptionsRadioName}
            value={addressOptions.suggested}
            title={t('Dirección sugerida')}
            description={<AddressOption address={suggestedAddress} differingFields={differingFields} />}
            selected={selectedOption === addressOptions.suggested}
            onChange={selectOption}
          />
        </Styles.Options>
        <Button onClick={confirmSelection} fullWidth>
          {t('Confirmar selección')}
        </Button>
      </Styles.Container>
    </Drawer>
  )
}

export default AddressSuggestionDrawer
